import { render, staticRenderFns } from "./TourBookingParams.vue?vue&type=template&id=bb12bb5e"
import script from "./TourBookingParams.vue?vue&type=script&lang=js"
export * from "./TourBookingParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports